import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";

import axios from "axios";

import { Provider } from "react-redux";

import { IntlProvider, addLocaleData } from "react-intl";
import locale_en from "react-intl/locale-data/en";
import locale_pl from "react-intl/locale-data/pl";
import locale_es from "react-intl/locale-data/es";
import messages_en from "./app/translations/en.json";
import messages_pl from "./app/translations/pl.json";
import messages_es from "./app/translations/es.json";

import * as authAction from "./app/actions/authActions";
import { fetchFlow24ServerConfig } from "./app/actions/flow24ServerActions";
import { getAuthToken } from "./app/helpers/storage";

import * as serviceWorker from "./serviceWorker";
import App from "./app/App";

import {
  axiosRequestAuthHeader,
  axiosResponseErrorHandler
} from "./app/helpers/api";
import { store } from "./app/helpers/store";
//import { setAuthenticationType, AuthenticationType } from './app/constants/AuthenticationType';

//const store = configureStore();

//########TRANSLACJE
addLocaleData([...locale_en, ...locale_pl, ...locale_es]);
const messages = {
  en: messages_en,
  pl: messages_pl,
  es: messages_es
};
//inicjalizacja lokalu - na ten moment na sztywno PL
//const language = navigator.language.split(/[-_]/)[0];  // language without region code
const language = "pl";

//RESET DEFAULT AUTHORIZATION TYPE
//setAuthenticationType(AuthenticationType.BASIC);

//######## AXIOS
axios.defaults.baseURL = process.env.REACT_APP_FLOW_API_SERVER;
axiosRequestAuthHeader();
axiosResponseErrorHandler();

//pytamy sie o zalogowanego uzytkownika jesli jest token
if (getAuthToken()) {
  store.dispatch(authAction.fetchMe());
}
store.dispatch(fetchFlow24ServerConfig());

ReactDOM.render(
  <Provider store={store}>
    <IntlProvider locale={language} messages={messages[language]}>
      <App />
    </IntlProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
